import React from 'react'
import { connect } from 'react-redux'
import Icon from '../icon'
import Text from '../text'
import StatusPlaceholder from '../placeholder/status_placeholder'
import { me } from '../../initial_state'
import TabBar from '../tab_bar'

class ListPreview extends React.PureComponent {
  render() {
    const { value, visibility } = this.props

    const title = value || 'Feed name'
    const block = {
      icon: visibility === 'private' ? 'unlocked-filled' : 'lock-filled',
      title: visibility === 'private' ? 'Private' : 'Public'
    }

    const tabs = [
      { title: 'Timeline', active: true },
      { title: 'Members', },
      { title: 'Subscribers', },
    ]

    return (
      <div className={[_s.d, _s.calcH106PX, _s.bgPrimary, _s.w50PC, _s.minW460PX, _s.maxW640PX, _s.mt15, _s.px15, _s.py15, _s.radiusSmall, _s.overflowHidden, _s.boxShadowModal, _s.mlAuto, _s.mrAuto].join(' ')}>

        <Text weight='bold' className={_s.mb15}>Preview</Text>
        <div
          className={[_s.d, _s.flex1, _s.bgPrimary, _s.radiusSmall, _s.overflowHidden, _s.border1PX, _s.borderColorSecondary].join(' ')}
        >
          <div className={[_s.d, _s.cursorNotAllowed, _s.posAbs, _s.top0, _s.left0, _s.right0, _s.bottom0, _s.z2].join(' ')} />
          <div style={{ filter: 'opacity(0.675) grayscale(1)' }}>
            <div>
              <div className={[_s.d, _s.w100PC, _s.jcCenter, _s.pt15, _s.px15].join(' ')}>
                <Text size='extraExtraLarge' weight='extraBold' color='secondary'>{title}</Text>
                <div className={[_s.d, _s.flexRow, _s.mt10, _s.aiCenter].join(' ')}>
                  <div className={[_s.d, _s.flexRow, _s.aiCenter].join(' ')}>
                    <Icon id={block.icon} size="12px" className={_s.cSecondary} />
                    <Text color="secondary" className={_s.ml5}>{block.title}</Text>
                  </div>
                  <Text size='small' color='secondary' className={[_s.mr5, _s.ml5].join(' ')}>·</Text>
                  <Text color="secondary">0 members</Text>
                  <Text size='small' color='secondary' className={[_s.mr5, _s.ml5].join(' ')}>·</Text>
                  <Text color="secondary">1 subscriber</Text>
                </div>
                <div className={[_s.d, _s.flexRow, _s.mt10].join(' ')}>
                  <Text color="secondary">Created by You</Text>
                </div>
              </div>
              <div className={[_s.d, _s.w100PC, _s.aiCenter, _s.jcCenter, _s.mlAuto, _s.mrAuto].join(' ')}>
                <div className={[_s.d, _s.w100PC, _s.flexRow, _s.borderBottom1PX, _s.borderColorSecondary, _s.maxH56PX].join(' ')}>
                  <TabBar tabs={tabs} isLarge />
                </div>
              </div>
            </div>
          </div>
          <div className={[_s.d, _s.mt15, _s.px15].join(' ')}>
            <StatusPlaceholder speed={0} interval={0} />
            <StatusPlaceholder speed={0} interval={0} />
            <StatusPlaceholder speed={0} interval={0} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  value: state.getIn(['list_editor', 'title']),
  visibility: state.getIn(['list_editor', 'visibility']),
  account: state.getIn(['accounts', me]),
})

export default connect(mapStateToProps)(ListPreview)
